import { Loader2 } from 'lucide-react'
import { runLine } from '@/app/document-review/run-select'
import type { DocumentReviewDetailOutput } from '@/app/document-review/use-document-review'

export function ProcessingPanel({ detail }: { detail: DocumentReviewDetailOutput }) {
  return (
    <div className="bg-card rounded-lg border p-4">
      <p className="text-muted-foreground flex items-center gap-2 text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin motion-reduce:animate-none" aria-hidden />
        {runLine(detail)}
      </p>
      <h2 className="mt-1 text-base font-medium">
        Processing the document{detail.traderName === null ? '' : ` for ${detail.traderName}`}
      </h2>
      <p className="text-muted-foreground mt-1 text-sm">Usually under a minute. Updates on its own.</p>
    </div>
  )
}

export function CreatingPanel({ detail }: { detail: DocumentReviewDetailOutput }) {
  return (
    <div className="bg-card rounded-lg border p-4">
      <p className="text-muted-foreground flex items-center gap-2 text-xs">
        <Loader2 className="h-3.5 w-3.5 animate-spin motion-reduce:animate-none" aria-hidden />
        {runLine(detail)}
      </p>
      <h2 className="mt-1 text-base font-medium">Creating the records</h2>
      <p className="text-muted-foreground mt-1 text-sm">
        Klear is creating the records. This page updates when they exist.
      </p>
    </div>
  )
}
